import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import getRedemptionsColumns from '../../../const/columns/redemptionsColumns'
import { getRedemptionsServer } from '../../../apis/Redemptions'

const Redemptions = () => {
  const [redemptions, setRedemptions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchRedemptions()
  }, [])

  const fetchRedemptions = async () => {
    try {
      const res = await getRedemptionsServer()
      setRedemptions(res.result)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const columns = getRedemptionsColumns()
  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className='table-respoinsive'>
                <Table
                  columns={columns}
                  dataSource={redemptions?.length > 0 ? redemptions : []}
                  className='table-striped '
                  rowKey={record => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Redemptions
